package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Skill_resource(
  public val id: String,
  public val skill_id: String,
  public val step_id: String?,
  public val origin: String,
  public val format: String,
  public val title: String,
  public val url: String?,
  public val body: String?,
  public val order_index: Long,
  public val index_status: String?,
  public val index_error: String?,
  public val indexed_at: Long?,
  public val refresh_error: String?,
  public val push_error: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
